import React from 'react';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';

import { isInternalURL } from '@plone/volto/helpers/Url/Url';
import MaybeWrap from '@plone/volto/components/manage/MaybeWrap/MaybeWrap';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import cx from 'classnames';
import config from '@plone/volto/registry';

const messages = defineMessages({
  PleaseChooseContent: {
    id: 'Please choose an existing content as source for this element',
    defaultMessage:
      'Please choose an existing content as source for this element',
  },
});

const TeaserBlockSAW = (props) => {
  const { className, data, isEditMode, style } = props;
  const intl = useIntl();
  const href = data.href?.[0];
  const image = data.preview_image?.[0];

  const Image = config.getComponent('Image').component;
  const { openExternalLinkInNewTab } = config.settings;

  if (!href && isEditMode) {
    return (
      <div className={cx('block teaser', className)} style={style}>
        <Message>
          <div className="teaser-item placeholder">
            <p>{intl.formatMessage(messages.PleaseChooseContent)}</p>
          </div>
        </Message>
      </div>
    );
  }

  if (!href) {
    return null;
  }

  const linkTarget =
    data.openLinkInNewTab ||
    (openExternalLinkInNewTab && !isInternalURL(href['@id']))
      ? '_blank'
      : null;

  return (
    <MaybeWrap
      condition={!isEditMode}
      as={UniversalLink}
      href={href['@id']}
      target={linkTarget}
    >
      <div className="teaser-item default saw-focustheme">
        <div className="image-wrappernot">
          {image ? (
            <Image
              item={props['@type'] === 'listing' ? null : image}
              imageField={image.image_field}
              alt=""
              loading="lazy"
              responsive={true}
            />
          ) : (
            <span className="donothing"></span>
          )}
        </div>
        <div className="content">
          {data?.head_title && (
            <div className="headline">{data.head_title}</div>
          )}
          <h3>{data?.title}</h3>
          <p className="description">{data.description}</p>
        </div>
      </div>
    </MaybeWrap>
  );
};

TeaserBlockSAW.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  isEditMode: PropTypes.bool,
};

export default TeaserBlockSAW;
